export * from './individuals.configuration';
